import { useEffect } from 'react';
var REFRESH_INTERVAL = 3000;

// Component that refreshes synced block subscriptions at regular intervals
// this is a workaround for the subscription mechanism not being real-time
export var SyncBlockRefresher = function SyncBlockRefresher(_ref) {
  var syncBlockStoreManager = _ref.syncBlockStoreManager;
  useEffect(function () {
    var interval = window.setInterval(function () {
      var _document;
      // check if document is visible to avoid unnecessary refreshes
      if (((_document = document) === null || _document === void 0 ? void 0 : _document.visibilityState) === 'visible') {
        syncBlockStoreManager.refreshSubscriptions();
      }
    }, REFRESH_INTERVAL);
    return function () {
      window.clearInterval(interval);
    };
  }, [syncBlockStoreManager]);
  return null;
};